import React from 'react';
import { connect } from 'react-redux';
import { MapZone } from './map.page.show.styled';
import { Col, Row } from 'reactstrap';
import Repeater from '@Utils/Repeater';
import { AppState } from '@Redux/store';
import { mapPresenter } from '@Selectors/ninthage/map.presenter';
import { useParams } from 'react-router-dom';
import { container } from '@Container';
import { TYPES } from '@Types';
import { Dispatch } from '@Redux/type';
import { MapAction } from '@Redux/actions/ninthAge/map.action';
import { MapElementView, TerrainView } from '@Selectors/ninthage/view/map.view';

const MapPageShow: React.FC<MapPageShowProps> = ({ initials, name, width, height, description, elements, terrains, load }) => {
  const params = useParams();
  const mapId = params.map_id;

  if (!mapId) {
    return <h1>No map found</h1>;
  }

  React.useEffect(() => {
    load(mapId);
  }, []);

  if(!width || !height) {
    return <h1>No map found</h1>;
  }

  const lines = Array(height)
    .fill(0)
    .map((_,index) => index + 1);
  const columns = Array(width)
    .fill(0)
    .map((_,index) => index + 1);

  return (
    <MapZone className={'row'}>
      <Col xs={12} lg={9} xlg={9} className="map-bg">
        <div className="bg-light-gray">
          <div className="map border border-black mt-3 mb-3 position-relative" style={{aspectRatio: width / height}}>
            <Repeater data={columns} indexPrefix='column'>
              {
                (column: number) => (
                  <span className={`position-absolute text-center`}
                        style={{
                          width: `${(1 / width) * 100}%`,
                          top: '2px',
                          left: `${((column - 1) / width) * 100}%`,
                          fontSize: '7px'
                        }}>{column}</span>
                )
              }
            </Repeater>
            <Repeater data={lines} indexPrefix='line'>
              {
                (line: number) => (
                  <span className={`position-absolute text-center`}
                        style={{
                          width: `${(1 / width) * 100}%`,
                          height: `${(1 / height) * 100}%`,
                          top: `${((line - 1) / height) * 100}%`,
                          left: 0,
                          fontSize: '7px'
                        }}>{line}</span>
                )
              }
            </Repeater>
            <Repeater data={elements} indexPrefix="decord">
              {
                (element: MapElementView) => (
                  <>
                    <img
                      src={`${process.env.CDN ?? ''}${element.logo}`}
                      className={`position-absolute z-1 ${element.rotation > 0 ? 'rotate-' + element.rotation : ''}`}
                      alt="Decor"
                      style={{
                        width: `${(element.width / width) * 100}%`,
                        height: `${(element.height / height) * 100}%`,
                        top: element.top && `${(( (element.rotation === 90 ? (element.width - element.height) / 2 : 0) + element.top) / height) * 100}%`,
                        right: element.right && `${(( (element.rotation === 90 ? (element.height - element.width) / 2 : 0) + element.right) / width) * 100}%`,
                        bottom: element.bottom && `${(((element.rotation === 90 ? (element.width - element.height) / 2 : 0) + element.bottom) / height) * 100}%`,
                        left: element.left && `${(((element.rotation === 90 ? (element.width - element.height) / 2 : 0) + element.left) / width) * 100}%`,
                      }}
                    />
                    {element.top && (
                      <div
                        className={'position-absolute z-0'}
                        style={{
                          height: `${(element.top / height) * 100}%`,
                          top: `0%`,
                          right: element.right && `${(element.right / width) * 100}%`,
                          left: element.left && `${(element.left / width) * 100}%`,
                          display: 'flex',
                        }}
                      >
                        <div
                          className="position-absolute bg-white z-0 rounded-top rounded-bottom"
                          style={{
                            top: '9px',
                            bottom: '9px',
                            left: '2.5px',
                            width: '15px',
                          }}
                        ></div>
                        <div className="text-center text-black z-3 d-flex flex-column justify-end h-100">
                          <span
                            className="mt-auto ms-1 ms-md-0 pb-2"
                            style={{
                              display: 'inline-block',
                              alignSelf: 'flex-end',
                            }}
                          >
                            {element.top}"
                          </span>
                        </div>
                      </div>
                    )}
                    {element.right && (
                      <div
                        className={'position-absolute z-0'}
                        style={{
                          width: `${(element.right / width) * 100}%`,
                          top: element.top && `${(element.top / height) * 100}%`,
                          right: `0%`,
                          bottom: element.bottom && `${(element.bottom / height) * 100}%`,
                        }}
                      >
                        <div
                          className="position-absolute bg-white z-0 rounded-start rounded-end"
                          style={{
                            top: '8px',
                            left: '5px',
                            right: '5px',
                            height: '14px',
                          }}
                        ></div>
                        <div className="d-flex">
                          <div className="flex-grow-1 pt-1 text-black z-2 ps-2">
                            {element.right}"
                          </div>
                        </div>
                      </div>
                    )}
                    {element.bottom && (
                      <div
                        className={'position-absolute z-0'}
                        style={{
                          height: `${(element.bottom / height) * 100}%`,
                          right: element.right && `${(element.right / width) * 100}%`,
                          bottom: `0%`,
                          left: element.left && `${(element.left / width) * 100}%`,
                        }}
                      >
                        <div
                          className="position-absolute bg-white z-0 rounded-top rounded-bottom"
                          style={{
                            top: '8px',
                            bottom: '8px',
                            left: '3px',
                            width: '15px',
                          }}
                        ></div>
                        <div className="position-relative h-100">
                          <div className="text-center text-black z-2 pt-2">
                            {element.bottom}"
                          </div>
                        </div>
                      </div>
                    )}
                    {element.left && (
                      <div
                        className={'position-absolute z-0'}
                        style={{
                          width: `${(element.left / width) * 100}%`,
                          top: element.top && `${(element.top / height) * 100}%`,
                          bottom: element.bottom && `${(element.bottom / height) * 100}%`,
                          left: `0%`,
                        }}
                      >
                        <div
                          className="position-absolute bg-white z-0 rounded-start rounded-end"
                          style={{
                            top: '8px',
                            left: '5px',
                            right: '5px',
                            height: '14px',
                          }}
                        ></div>
                        <div className="d-flex">
                          <div className="flex-grow-1 text-end pt-1 pe-2 text-black z-2">
                            {element.left}"
                          </div>
                        </div>
                      </div>
                    )}
                  </>
                )
              }
            </Repeater>
          </div>
        </div>
      </Col>
      <Col xs={12} lg={3} xlg={3}>
        <h1 className="text-center">{initials} - {name}</h1>
        <p>{description}</p>
        <Row>
          <Col xs={6} className="text-center">
            Width: {width}"
          </Col>
          <Col xs={6} className="text-center">
            Height: {height}"
          </Col>
        </Row>
        <Row>
          <Repeater data={elements} indexPrefix="decord">
            {(element: MapElementView) => {
              return (
                <Col xs={12} md={12} lg={6}>
                  <div className="d-flex m-1">
                    <div>
                      <img
                        src={`${process.env.CDN ?? ''}${element.logo}`}
                        className={`mx-auto d-block ${element.rotation > 0 ? 'rotate-' + element.rotation : ''}`}
                        alt="Decor"
                        style={{
                          aspectRatio: 'auto',
                          maxWidth: 75,
                          maxHeight: 75,
                        }}
                      />
                    </div>
                    <div className="ms-1">
                      <span className="fw-bold">{element.name}:</span>
                      {element.top && <div>Top: {element.top}"</div>}
                      {element.right && <div>Right: {element.right}"</div>}
                      {element.bottom && <div>Bottom: {element.bottom}"</div>}
                      {element.left && <div>Left: {element.left}"</div>}
                    </div>
                  </div>
                </Col>
              );
            }}
          </Repeater>
        </Row>
      </Col>
      <Col xs={12} lg={3}>
        <h2>Terrain Feature Sizes</h2>
        <Row>
          <Repeater data={terrains} indexPrefix="decord">
            {(decor: TerrainView) => {
              return (
                <Col xs={12} md={12} lg={6}>
                  <div className="d-flex m-1">
                    <div>
                      <img
                        src={`${process.env.CDN ?? ''}${decor.logo}`}
                        alt="Decor"
                        className="mx-auto d-block"
                        style={{
                          aspectRatio: 'auto',
                          maxWidth: 75,
                          maxHeight: 75,
                        }}
                      />
                    </div>
                    <div className="ms-1">
                      <span className="fw-bold">{decor.name}:</span>
                      <p>{decor.size}</p>
                    </div>
                  </div>
                </Col>
              );
            }}
          </Repeater>
        </Row>
      </Col>
    </MapZone>
  );
};

const mapStateToProps = (state: AppState) => ({
  ...mapPresenter(state),
});

const mapDispatchToProps = (dispatch: Dispatch) => {
  const mapAction = container.get<MapAction>(TYPES.Actions.MapAction);
  return {
    load: (mapId: string) => dispatch(mapAction.fetchData({ entityId: parseInt(mapId) })),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(MapPageShow);

type MapPageShowProps = ReturnType<typeof mapDispatchToProps> &
  ReturnType<typeof mapStateToProps>;
